import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import {Accordion, AccordionHeader, AccordionItem, AccordionPanel} from '@adv-mt/ui/accordion'
import {Subhead1} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import {ACCORDION_HEADER_ICONS} from '../accordionHeaderIcons.js'
import BaseDrawer from '../BaseDrawer/index.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-sellerServicesDrawer`

const SHIPPING_BENEFIT_KEYS = [
  'MORE_CAR_DEALS',
  'WITHOUT_MOVING',
  'PURCHASE_OPTIONS',
  'AGREEMENT_WITH_SELLER',
  'WARRANTY_OUR_PROFESSIONALS'
]

const SellerServicesDrawer = ({hasShipping = false, onClose, services = []}) => {
  const {i18n} = useSuiContext()

  const shippingBenefits = hasShipping
    ? SHIPPING_BENEFIT_KEYS.map(key => ({
        description: i18n.t(`DEALER_LOCATIONS.${key}_DESCRIPTION`),
        id: key,
        title: i18n.t(`DEALER_LOCATIONS.${key}_NAME`)
      }))
    : []

  const availableServices = services
    .filter(({description, title}) => Boolean(title) && Boolean(description))
    .map(({description, title, type}) => ({description, id: type, title}))

  const renderSection = (items, title) =>
    items.length > 0 && (
      <div className={`${BASE_CLASS}-section`}>
        {title && (
          <Subhead1 as="h3" className={`${BASE_CLASS}-sectionTitle`}>
            {title}
          </Subhead1>
        )}
        <Accordion openMultiple>
          {items.map(({description, id, title: itemTitle}) => (
            <AccordionItem key={id} value={id}>
              <AccordionHeader {...ACCORDION_HEADER_ICONS}>{itemTitle}</AccordionHeader>
              <AccordionPanel>{description}</AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    )

  return (
    <BaseDrawer onClose={onClose} title={i18n.t('SELLER.SERVICES_DRAWER_TITLE')}>
      <div className={BASE_CLASS}>
        {renderSection(
          shippingBenefits,
          availableServices.length > 0 ? i18n.t('DEALER_LOCATIONS.DEALER_LOCATIONS_TITLE') : null
        )}
        {renderSection(availableServices, hasShipping ? i18n.t('SELLER.OTHER_SERVICES_AVAILABLE_TITLE') : null)}
      </div>
    </BaseDrawer>
  )
}

SellerServicesDrawer.displayName = 'SellerServicesDrawer'

SellerServicesDrawer.propTypes = {
  hasShipping: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  services: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      title: PropTypes.string,
      type: PropTypes.string
    })
  )
}

export default SellerServicesDrawer
